import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IDelinquentClaimsBriefDto } from '@/dtos';

const QUERY_KEY = 'DELINQUENT_CLAIMS_BRIEF_QUERY';

const useDelinquentClaimsBriefQuery = () => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY],
    () => api.get<IDelinquentClaimsBriefDto>(API_URL.REPORTS_DELINQUENT_CLAIMS_REPORT_BRIEF),
    {
      cacheTime: 0,
      retry: 0,
    }
  );

  const formattedData = useMemo(() => {
    const response = data?.data;
    return {
      repaymentRequiredCount: response?.repayment_required_count ?? 0,
      lockedPursesCount: response?.locked_purses_count ?? null,
      isDelinquentClaimsShowed: response?.show_delinquent_claims_report || false,
    };
  }, [data?.data]);

  return {
    isSuccess,
    isLoading,
    data: formattedData,
  };
};

export default useDelinquentClaimsBriefQuery;
